/** What the Pay rates card shows before it has rates: loading, or why not. */
import { Loader2 } from 'lucide-react';

import PayRatesCardFrame from './PayRatesCardFrame';

export default function PayRatesLoadState({
  loadError,
  onRetry,
}: {
  loadError: string | null;
  onRetry: () => void;
}) {
  if (!loadError) {
    return (
      <PayRatesCardFrame>
        <p
          role="status"
          className="flex items-center gap-2 text-sm text-stone-600 dark:text-stone-400"
        >
          <Loader2 size={16} className="animate-spin" aria-hidden="true" />
          Loading pay rates
        </p>
      </PayRatesCardFrame>
    );
  }
  return (
    <PayRatesCardFrame>
      <p role="alert" className="text-sm text-red-700 dark:text-red-400">
        {loadError}
      </p>
      <button
        type="button"
        onClick={onRetry}
        className="mt-2 min-h-[24px] text-sm text-moss-700 dark:text-moss-400 hover:underline"
      >
        Try again
      </button>
    </PayRatesCardFrame>
  );
}
